import { BaseService } from './base.service';
import { Taxonomy, TaxonomyDimensionConfig, TaxonomyType } from '@/types/taxonomy';

class TaxonomyService extends BaseService {
  constructor() {
    super('/content-library/taxonomy');
  }

  // Response is a bare array, not a paginated envelope.
  async listTaxonomy(params: { type?: TaxonomyType; isActive?: boolean }): Promise<Taxonomy[]> {
    const query = new URLSearchParams();
    if (params.type) query.set('type', params.type);
    if (params.isActive !== undefined) query.set('isActive', String(params.isActive));
    const qs = query.toString();
    return this.get<Taxonomy[]>(qs ? `?${qs}` : '');
  }

  // Fuzzy/case-insensitive find-or-create — returns the existing match or a
  // newly-created taxonomy value for the given dimension.
  async findOrCreate(type: TaxonomyType, value: string): Promise<Taxonomy> {
    return this.post<Taxonomy>(`/${type}/find-or-create`, { value });
  }

  async listDimensionConfig(): Promise<TaxonomyDimensionConfig[]> {
    return this.get<TaxonomyDimensionConfig[]>('/config');
  }
}

export const taxonomyService = new TaxonomyService();
